/* eslint-disable react-hooks/exhaustive-deps */

import { useCallback, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
} from "@material-ui/core";

import componentStyles from "assets/theme/views/auth/login.js";
import componentStylesButtons from "assets/theme/components/button.js";

import Api from "lib/api/httpRequestHelper.js";
import UtilsFncs from "utils/UtilsFncs";

import useAlert from "components/Alerts/useAlert";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(componentStylesButtons);

function RedirectPage({ match }) {
  const classes = {
    ...useStyles(),
    ...useStylesButtons(),
  };
  const { alert, closeAlert, showErrorAlert } = useAlert();

  const handleErrorConfirmation = useCallback(() => {
    closeAlert();
    UtilsFncs.RedirectToLoginPage();
  }, [closeAlert]);

  useEffect(() => {
    fetchRealUrl();
  }, []);

  const fetchRealUrl = async () => {
    await Api.get(
      "get-url-shortener",
      "urlshortener",
      "?codIdLink=" + match.params.url,
      false
    )
      .then(({ Result, Success }) => {
        if (Success) {
          window.location.href = Result.Url;
        }
      })
      .catch((error) => {
        console.log({ error });

        showErrorAlert(
          error,
          "Ops!",
          handleErrorConfirmation,
          handleErrorConfirmation,
          "Ir para o Login"
        );
      });
  };

  return (
    <>
      {alert}
      <Container
        component={Box}
        maxWidth="xl"
        display="flex"
        position="relative"
        justifyContent="center"
        alignItems="center"
        marginTop="2rem"
      >
        <Box component={Grid} container justifyContent="center">
          <Grid item xs={12} lg={5} md={7}>
            <Card classes={{ root: classes.cardRoot }}>

              <CardContent classes={{ root: classes.cardContent }}>
                <Box
                  textAlign="center"
                  marginTop="1.5rem"
                  marginBottom="1.5rem"
                >
                  Redirecionando URL...
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Box>
      </Container>
    </>
  );
}

RedirectPage.propTypes = {};

export default RedirectPage;
